export const SFCC_INTEGRATION_CLASS = 'SfccCustom';
